var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.7 45.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 45.3h40c4.1 0 6.6-4.4 4.6-8l-20-34.7c-2-3.5-7.1-3.5-9.2 0L.7 37.3c-2 3.6.5 8 4.6 8zm20-18.6c-1.5 0-2.7-1.2-2.7-2.7v-5.3c0-1.5 1.2-2.7 2.7-2.7s2.7 1.2 2.7 2.7V24c0 1.5-1.2 2.7-2.7 2.7zM28 37.3h-5.3V32H28v5.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ff8000"
  })));
}
export default SvgWarning;